import React from "react";
import BrandItem from "../BrandItem";
var LogosList = function (props) {
    return (React.createElement("ul", { className: "c-Brands__list reset" }, props.brands.map(function (item, index) {
        return React.createElement(BrandItem, { brands: item, key: item.id + "-" + index });
    })));
};
export default LogosList;
